import formStyles from "../../../GeneralStyles/formStyle";
const useStyles = (theme) => ({
    ...formStyles(theme),
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});

export default useStyles;
